/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { WithRealmNameItemRequestBuilderNavigationMetadata } from './item/index.js';
/**
 * Uri template for the request builder.
 */
export const ApiRequestBuilderUriTemplate = "{+baseurl}/admin/api";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiRequestBuilderNavigationMetadata = {
    byRealmName: {
        navigationMetadata: WithRealmNameItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["realmName"],
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map